import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { LanguageModule } from '@language';
import {
    CopyButtonComponent,
    ShActionItemComponent,
    ShDynamicDialogModule,
    ShDynamicDialogService,
    ShFacetComponent,
    ShFormCheckboxBaseComponent,
    ShFormDateComponent,
    ShFormMultiSelectModule,
    ShFormSelectComponent,
    ShHtmlParserComponent,
    ShIconModule,
    ShNotificationComponent
} from '@stylehaven/components';
import { ClipboardModule } from 'ngx-clipboard';
import { LoadingModule } from '../loading/loading.module';
import { ThesaurusModule } from '../thesaurus/thesaurus.module';
import { BatchLimitDialogComponent } from './batch-limit-dialog/batch-limit-dialog.component';
import { ComplexValueDialogComponent } from './complex-value-dialog/complex-value-dialog.component';
import { MediahavenShareDialogComponent } from './mediahaven-share-dialog/mediahaven-share-dialog.component';
import { NoRolesDialogComponent } from './no-roles-dialog/no-roles-dialog.component';
import { PortalShareDialogComponent } from './portal-share-dialog/portal-share-dialog.component';
import { ThesaurusConceptDialogComponent } from './thesaurus-concept-dialog/thesaurus-concept-dialog.component';
import { ThesaurusTreeDialogComponent } from './thesaurus-tree-dialog/thesaurus-tree-dialog.component';

@NgModule({
    declarations: [
        ThesaurusConceptDialogComponent,
        ThesaurusTreeDialogComponent,
        MediahavenShareDialogComponent,
        PortalShareDialogComponent,
        ComplexValueDialogComponent,
        BatchLimitDialogComponent,
        NoRolesDialogComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        ThesaurusModule,
        LoadingModule,
        LanguageModule,
        ThesaurusModule,
        ClipboardModule,
        LoadingModule,
        CopyButtonComponent,

        ShIconModule,
        ShFormSelectComponent,
        ShActionItemComponent,
        ShFormMultiSelectModule,
        ShDynamicDialogModule,
        ShNotificationComponent,
        ShHtmlParserComponent,
        ShFacetComponent,
        ShFormCheckboxBaseComponent,
        ShFormDateComponent,
        CopyButtonComponent
    ],
    exports: [
        ThesaurusConceptDialogComponent,
        ThesaurusTreeDialogComponent,
        MediahavenShareDialogComponent,
        ComplexValueDialogComponent,
        BatchLimitDialogComponent,
        NoRolesDialogComponent
    ],
    providers: [ShDynamicDialogService]
})
export class SharedDialogModule {}

export { BatchLimitDialogComponent } from './batch-limit-dialog/batch-limit-dialog.component';
export { FacetSearchDialogConfig } from './entities/facet-search-dialog-config.entity';
export * from './entities/facet-search-dialog.entity';
export * from './entities/selection-dialog.entity';
export { MediahavenShareDialogConfig, PortalShareDialogConfig } from './entities/share-dialog-config.entity';
export * from './entities/thesaurus-suggestion-dialog.entity';
export * from './helpers/dialog.helper';
export { toSelectableFacetValue } from './helpers/selectable-facet-value.helper';
export { ListPreviewModalContainerComponent } from './list-preview-dialog/list-preview-dialog-container.component';
export { PreviewDialogActionsService } from './list-preview-dialog/preview-dialog-actions.service';
export { MediahavenShareDialogComponent } from './mediahaven-share-dialog/mediahaven-share-dialog.component';
export { NoRolesDialogComponent } from './no-roles-dialog/no-roles-dialog.component';
export { PortalShareDialogComponent } from './portal-share-dialog/portal-share-dialog.component';
export { ThesaurusConceptDialogComponent } from './thesaurus-concept-dialog/thesaurus-concept-dialog.component';
export { ThesaurusTreeDialogComponent } from './thesaurus-tree-dialog/thesaurus-tree-dialog.component';
